<nz-tabset [nzDestroyInactiveTabPane]="true">
  <nz-tab nzTitle="Data Connection">
    <ng-template nz-tab>
      <nz-row nzJustify="end" nzAlign="middle" *ngIf="authService.hasEntitlements(createDataConnectionModule)">
        <nz-col>
          <button nz-button nzType="primary" nzSize="large" [routerLink]="'/data-connection/create'">
            <i nz-icon nzType="plus"></i>
            Add Data Connection
          </button>
        </nz-col>
      </nz-row>
      <div class="data-connections-table table-content">
        <nz-table
          #nestedTable
          [nzData]="dataConnectionListData"
          [nzShowPagination]="false"
          [nzScroll]="{ x: '100rem', y: 'calc(100vh - 250px)' }"
          [nzLoading]="isLoading"
          nzTableLayout="fixed"
        >
          <thead>
            <tr>
              <th nzWidth="72px"></th>
              <th nzWidth="420px">Connection Name</th>
              <th nzWidth="160px">Datasource Type</th>
              <th nzWidth="120px">Status</th>
              <th>Created By</th>
              <th>Created At</th>
              <th
                [nzSortOrder]="'descend'"
                [nzSortFn]="sortByLastModifiedAt"
                [nzSortDirections]="['ascend', 'descend', null]"
              >
                Last Modified At
              </th>
              <th nzWidth="102px" nzRight>Actions</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let data of nestedTable.data">
              <tr>
                <td [(nzExpand)]="data.expand"></td>
                <td>{{ data.connectionName }}</td>
                <td>{{ data.connectionType }}</td>
                <td nzAlign="center">
                  <nz-tag [nzColor]="getColorCode(data.connectionStatus)">{{ data.connectionStatus }}</nz-tag>
                </td>
                <td>{{ data.createdBy }}</td>
                <td>{{ data.createdAt | dateTime }}</td>
                <td>{{ data.lastModifiedAt | dateTime }}</td>
                <td nzRight>
                  <button nz-button nz-dropdown [nzDropdownMenu]="actionMenu">
                    <span nz-icon nzType="more"></span>
                  </button>
                  <nz-dropdown-menu #actionMenu="nzDropdownMenu">
                    <ul nz-menu>
                      <li
                        nz-menu-item
                        *ngIf="
                          data?.connectionStatus === 'INACTIVE' &&
                          authService.hasEntitlements(hasDataConnectionActionEntitlement)
                        "
                        (click)="openDataConnectionActionsModal(data, dataConnectionActions.REACTIVATE)"
                      >
                        Reactivate
                      </li>
                      <li
                        nz-menu-item
                        *ngIf="
                          data?.connectionType !== 'GRIDIRON_LF' &&
                          data?.connectionStatus === 'SUCCESS' &&
                          authService.hasEntitlements(hasDataConnectionActionEntitlement)
                        "
                        (click)="openDataConnectionActionsModal(data, dataConnectionActions.DEACTIVATE)"
                      >
                        Deactivate
                      </li>
                      <li
                        nz-menu-item
                        *ngIf="
                          data?.connectionType !== 'GRIDIRON_LF' &&
                          authService.hasEntitlements(hasDataConnectionActionEntitlement)
                        "
                        (click)="openDataConnectionActionsModal(data, dataConnectionActions.DELETE)"
                      >
                        Delete
                      </li>
                      <li
                        nz-menu-item
                        *ngIf="
                          data?.connectionType === 'SFTP' &&
                          data?.connectionStatus === 'SUCCESS' &&
                          authService.hasEntitlements(hasDataConnectionActionEntitlement)
                        "
                        [routerLink]="['/data-connection/edit', data.connectionId]"
                      >
                        Add New Files
                      </li>
                    </ul>
                  </nz-dropdown-menu>
                </td>
              </tr>
              <tr [nzExpand]="data.expand">
                <nz-table
                  #innerTable
                  [nzData]="data.metadataList"
                  nzSize="middle"
                  [nzShowPagination]="false"
                  nzTableLayout="fixed"
                >
                  <thead>
                    <tr>
                      <th>Table Name</th>
                      <th>Schema Name</th>
                      <th width="10%">Sync Status</th>
                      <th width="5%" nzRight>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let metadata of data.metadataList">
                      <tr>
                        <td>{{ metadata.table_name }}</td>
                        <td>{{ metadata.database_name }}</td>
                        <td>
                          <nz-tag [nzColor]="getColorCode(metadata.sync_status)">{{ metadata.sync_status }}</nz-tag>
                        </td>
                        <td nzRight>
                          <button nz-button nz-dropdown [nzDropdownMenu]="actionMenu">
                            <span nz-icon nzType="more"></span>
                          </button>
                          <nz-dropdown-menu #actionMenu="nzDropdownMenu">
                            <ul nz-menu>
                              <li
                                nz-menu-item
                                *ngIf="
                                  authService.hasEntitlements(hasDataConnectionActionEntitlement) &&
                                  metadata.sync_status !== 'INACTIVE'
                                "
                                [routerLink]="['/data-connection-mapping/edit', data.connectionId, metadata.table_name]"
                              >
                                Edit
                              </li>
                              <li
                                nz-menu-item
                                *ngIf="
                                  data?.connectionType !== 'GRIDIRON_LF' &&
                                  authService.hasEntitlements(hasDataConnectionActionEntitlement) &&
                                  metadata.sync_status === 'ACTIVE'
                                "
                                (click)="
                                  openDataConnectionActionsModal(
                                    data,
                                    dataConnectionActions.DEACTIVATE,
                                    metadata.table_name!
                                  )
                                "
                              >
                                Deactivate
                              </li>
                              <li
                                nz-menu-item
                                *ngIf="
                                  authService.hasEntitlements(hasDataConnectionActionEntitlement) &&
                                  metadata.sync_status === 'INACTIVE'
                                "
                                (click)="
                                  openDataConnectionActionsModal(
                                    data,
                                    dataConnectionActions.REACTIVATE,
                                    metadata.table_name!
                                  )
                                "
                              >
                                Reactivate
                              </li>
                            </ul>
                          </nz-dropdown-menu>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </nz-table>
              </tr>
            </ng-container>
          </tbody>
        </nz-table>
      </div>
    </ng-template>
  </nz-tab>
</nz-tabset>
